var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.53488C6.77256 2.53488 2.53488 6.77256 2.53488 12C2.53488 17.2274 6.77256 21.4651 12 21.4651C12.009 21.4651 12.018 21.4651 12.0269 21.4649C11.5194 20.4966 11.2326 19.3934 11.2326 18.2267C11.2326 14.3678 14.3678 11.2326 18.2267 11.2326C19.3934 11.2326 20.4966 11.5194 21.4649 12.0269C21.4651 12.018 21.4651 12.009 21.4651 12C21.4651 6.77256 17.2274 2.53488 12 2.53488ZM20.9194 13.4777C20.1261 13.0257 19.2064 12.7674 18.2267 12.7674C15.2155 12.7674 12.7674 15.2155 12.7674 18.2267C12.7674 19.2064 13.0257 20.1261 13.4777 20.9194C13.5986 20.8272 13.7153 20.7249 13.8264 20.6138L20.6138 13.8264C20.7249 13.7153 20.8272 13.5986 20.9194 13.4777ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 12.5566 22.8693 13.0829 22.6517 13.5594C22.4188 14.0697 22.0855 14.5254 21.6991 14.9118L14.9118 21.6991C14.5254 22.0855 14.0697 22.4188 13.5594 22.6517C13.0829 22.8693 12.5566 23 12 23C5.92487 23 1 18.0751 1 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCategory);
export default __webpack_public_path__ + "static/media/no_category.3628cf6b27e5ef7c8b9c173d89f0dc07.svg";
export { ForwardRef as ReactComponent };